// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardTileBody.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = require('react');
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = require('mobx-react').propTypes;
  var DashboardConstants = require('logic/data/Izenda.DashboardConstants');
  var observer = require('mobx-react').observer;

  var TileComponents = {
    Text: {
      FrontSide: require('./TextTile/Izenda.TextTileFrontSide'),
      BackSide : require('./TextTile/Izenda.TextTileBackSide')
    },
    ReportPart: {
      FrontSide: require('./ReportPartTile/Izenda.ReportPartTileFrontSide'),
      BackSide : require('./ReportPartTile/Izenda.ReportPartTileBackSide')
    }
  };

  var DashboardTileBody = function (props) {
    var dashboardPart = props.dashboardPart;
    var edit = !props.viewMode;

    var type = dashboardPart.type;
    var isBackSide = dashboardPart.isBackSide;

    var Tile = (type === DashboardConstants.TILE_TYPE.text.type)
      ? TileComponents.Text
      : TileComponents.ReportPart;

    var SideComponent = (edit && isBackSide)
      ? Tile.BackSide
      : Tile.FrontSide;

    return <SideComponent {...props} />;
  };
  DashboardTileBody.propTypes = {
    dashboardPart : ObservablePropTypes.observableObject,
    viewMode: PropTypes.bool
  };

  module.exports = observer(DashboardTileBody);
}();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/Izenda.DashboardTileBody.jsx